import { Helper } from '@/mixin/helper'
import store from '@/state/store'
const hasAccessAll = store.getters['identity/hasAccessAll']
import { setNavSource } from '@/helpers/navigation-guards'

export default [
  {
    path: '/fleet-task/',
    name: 'Fleet Task',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const hasTms = hasAccessAll(['tms:create', 'tms:read', 'tms:update', 'tms:delete'])
        const hasFti = hasAccessAll([
          'fleet-task-instant:create',
          'fleet-task-instant:read',
          'fleet-task-instant:update',
          'fleet-task-instant:delete',
        ])
        if (!hasTms && !hasFti) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () => import('@/router/views/fleet-task/'),
  },
  {
    path: '/fleet-task/import',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = hasAccessAll(['tms:create', 'tms:read', 'tms:update', 'tms:delete'])
        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () => import('@/router/views/fleet-task/import'),
    children: [
      {
        path: '',
        name: 'Fleet Task Import',
        component: () => import('@/router/views/fleet-task/import/contents/Upload.vue'),
      },
      {
        path: ':id',
        name: 'Fleet Task Import Detail',
        component: () => import('@/router/views/fleet-task/import/contents/Process.vue'),
      },
      {
        path: ':id/result',
        name: 'Fleet Task Import Result',
        component: () => import('@/router/views/fleet-task/import/contents/Result.vue'),
      },
    ],
  },
  {
    path: '/fleet-task/create',
    name: 'Fleet Task Create',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = hasAccessAll(['tms:create', 'tms:read', 'tms:update', 'tms:delete'])
        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () => import('@/router/views/fleet-task/attach-delivery'),
  },
  {
    path: '/fleet-task/:id/attach-delivery',
    name: 'Fleet Task Attach Delivery',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = hasAccessAll(['tms:create', 'tms:read', 'tms:update', 'tms:delete'])
        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () => import('@/router/views/fleet-task/attach-delivery'),
  },
  {
    path: '/fleet-task/:id',
    name: 'Fleet Task Detail',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = hasAccessAll(['tms:create', 'tms:read', 'tms:update', 'tms:delete'])
        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    beforeEnter: setNavSource,
    component: () => import('@/router/views/fleet-task/form'),
  },
  {
    path: '/fleet-task/track/:data',
    name: 'Track FO',
    meta: {
      guestPage: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        next()
      },
    },
    component: () => import('@/router/views/fleet-task/liveTrack/index'),
  },
]
